<template>
  <div
    class="app-time-select"
    v-click-outside="
      () => {
        this.pickerEnabled = false
      }
    "
  >
    <div class="time-selector">
      <input
        type="text"
        :class="['form-control time', { 'is-invalid': !isValid_ }]"
        :value="timeLabel"
        @change="updateTime($event.target.value)"
        @keyup.enter="pickerEnabled = false"
        :disabled="disabled"
        @click="openPicker"
      />
      <i :class="['ion ion-ios-arrow-down arrow', { disabled: options.length === 0 }]" @click="openPicker"></i>
    </div>
    <div class="picker" v-if="pickerEnabled" @keyup.esc="pickerEnabled = false">
      <div class="options" ref="options">
        <div :class="['option', { active: option.active }]" v-for="(option, i) in options" :key="i" @click="optionSelect(option)">
          {{ option.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTimeSelect',
  props: {
    time: {
      type: String,
      default: ''
    },
    optionsStep: {
      type: Number,
      default: 30
    },
    showInterval: {
      type: Boolean,
      default: true
    },
    fromTime: {
      type: String,
      default: ''
    },
    isValid: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isValidFormat: true,
    pickerEnabled: false,
    hour: 9,
    minute: 0,
    fromHour: 0,
    fromMinute: 0
  }),
  computed: {
    isValid_() {
      return this.isValid && this.isValidFormat
    },
    timeLabel() {
      return `${this.hour}:${this.minute < 10 ? '0' : ''}${this.minute}`
    },
    options() {
      const options = []
      const dayMinutes = 1440
      const steps = Math.ceil(dayMinutes / this.optionsStep)
      for (let i = 0; i < steps; i++) {
        let active = false
        const stepTime = (i * this.optionsStep) / 60
        const hour = Math.floor(stepTime)
        if (this.hour === hour) {
          active = true
        }
        const minute = ((stepTime - hour) * 60).toFixed(0)
        if (hour >= this.fromHour + 1) {
          options.push({ title: `${hour}:${minute < 10 ? '0' : ''}${minute}${this.calcFromDiffTitle({ hour, minute })}`, active })
        }
      }

      return options
    }
  },
  methods: {
    openPicker() {
      if (this.disabled) return
      this.pickerEnabled = true
      this.$nextTick(() => {
        let activeOption = this.$refs.options.getElementsByClassName('active')[0]
        if (activeOption) activeOption.scrollIntoView()
      })
    },
    calcFromDiffTitle(toTime) {
      if (this.fromTime) {
        const hourDiff = toTime.hour - this.fromHour
        let minuteDiff = toTime.minute - this.fromMinute
        if (hourDiff >= 0 || minuteDiff >= 0) {
          minuteDiff = minuteDiff / 60
          return ` (${(parseFloat(hourDiff) + parseFloat(minuteDiff)).toFixed(1)}h)`
        }
      }
      return ''
    },
    parseTime(time) {
      if (time) {
        let parts = time.split(':')
        if (parts.length === 2) {
          let hour = parseInt(parts[0])
          let minute = parseInt(parts[1])
          if (isNaN(hour) || isNaN(minute) || hour > 24 || hour < 0 || minute > 59 || minute < 0) {
            return false
          }
          return { minute, hour, totalMinutes: hour * 60 + minute }
        }
        return false
      }
    },
    updateTime(time) {
      let timeParsed = this.parseTime(time)
      if (timeParsed) {
        this.isValidFormat = true
        if (this.minute !== timeParsed.minute || this.hour !== timeParsed.hour) {
          this.minute = timeParsed.minute
          this.hour = timeParsed.hour
          this.$emit('change', timeParsed)
        }
      } else if (time) {
        this.isValidFormat = false
      }
    },
    optionSelect(option) {
      this.updateTime(option.title)
      this.pickerEnabled = false
    }
  },
  watch: {
    time: {
      immediate: true,
      handler(time) {
        this.updateTime(time)
      }
    },
    fromTime: {
      immediate: true,
      handler(newTime, prevTime) {
        const newTimeParsed = this.parseTime(newTime)
        if (newTimeParsed) {
          const prevTimeParsed = this.parseTime(prevTime)
          if (prevTimeParsed) {
            const minutesDiff = newTimeParsed.totalMinutes - prevTimeParsed.totalMinutes
            if (minutesDiff !== 0) {
              const to = this.hour * 60 + this.minute + minutesDiff
              const toHour = Math.floor(to / 60)
              const toMinute = to % 60
              if (toHour < 24 && toHour > -1 && toMinute < 60 && toMinute > -1) {
                this.updateTime(`${toHour}:${toMinute}`)
              }
            }
          }
          this.fromHour = newTimeParsed.hour
          this.fromMinute = newTimeParsed.minute
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-time-select {
  position: relative;
}

.time-selector {
  position: relative;
}

.time {
  padding-left: 7px;
  padding-right: 7px;
}

.arrow {
  position: absolute;
  right: 5px;
  top: 33%;
  cursor: pointer;

  &.disabled {
    opacity: 0.5;
  }
}

.picker {
  position: absolute;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
  z-index: 1;
  right: 0;
}

.options {
  max-height: 250px;
  overflow-y: scroll;
  overflow-x: hidden;

  .option {
    padding: 5px 8px;
    display: block;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
      background: #ccc;
    }
  }
}
</style>
